import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import Widget from "./WidgetMensaje/Widget";

function BaseTemplate(props) {
  return (
    <div>
      <Nav />
      <div className="min-h-screen mb-8">{props.children}</div>
      <Widget />
      <Footer />
    </div>
  );
}
export default BaseTemplate;
